import { useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FilterToggle from "../../atoms/FilterToggle";

const inmobiliariasOptions = [
  { value: "1", label: "Aledra" },
  { value: "2", label: "Comerdesa" },
  { value: "3", label: "Otros" },
];

const FilterStats = ({ setFilters }) => {
  const [localFilters, setLocalFilters] = useState({
    inmobiliaria: null,
    dateRange: { start: null, end: null },
  });

  const handleInmobiliariaChange = (option) => {
    setLocalFilters((prev) => ({ ...prev, inmobiliaria: option }));
    setFilters((prev) => ({ ...prev, inmobiliaria: option }));
  };

  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setLocalFilters((prev) => ({ ...prev, dateRange: { start, end } }));
    setFilters((prev) => ({ ...prev, dateRange: { start, end } }));
  };

  const handleReset = () => {
    const reset = {
      inmobiliaria: null,
      dateRange: { start: null, end: null },
    };
    setLocalFilters(reset);
    setFilters(reset);
  };

  return (
    <FilterToggle>
      <div className="w-full flex flex-col space-y-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2">

          <div>
            <Select
              value={localFilters.inmobiliaria}
              onChange={handleInmobiliariaChange}
              options={inmobiliariasOptions}
              isClearable
              placeholder="Selecciona inmobiliaria"
            />
          </div>

          <div>
            <DatePicker
              selectsRange
              startDate={localFilters.dateRange.start}
              endDate={localFilters.dateRange.end}
              placeholderText="Rango de fechas"
              onChange={handleDateRangeChange}
              isClearable
              className="w-full border-[1.7px] border-gray-400/55 rounded p-2 text-sm placeholder:text-gray-500"
            />
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={handleReset}
            className="text-gray-500 text-xs p-1"
          >
            Limpiar filtros
          </button>
        </div>
      </div>
    </FilterToggle>
  );
};

export default FilterStats;
